module.exports = __webpack_public_path__ + "static/media/logo-contigo-white.1addb78d.png";